import { defaults, state } from '@frameio/graphql-client';

/**
 * Drops an asset's transfer-state entry. A plain delete won't notify mounted
 * subscribers, so broadcast the terminal state first, then remove the entry.
 */
export function removeTransferState(key: string) {
  if (!key) return;
  if (!state.transfers.transferJobTasks.has(key)) return;

  state.transfers.transferJobTasks.set(
    key,
    defaults.transfers.DEFAULT_TRANSFER_JOB_TASK_STATE
  );
  state.transfers.transferJobTasks.delete(key);
}
